<div class="body-header">
  <h3 translate>verify-id.component.title</h3>
</div>

<div class="body-content">
  <div class="content" translate>verify-id.component.content</div>

  <lv-photo-help photoType="id" lvCloseOverlay withKeyboard="esc">
    <div class="photo-wrapper">
      @if (photo) {
        <img id="the-photo" [src]="photoURL" />

        @if (showTryAgainButton) {
          <button class="button is-secondary is-fullwidth" (click)="reset()">
            <span class="icon">
              <i lvIcon="refresh"></i>
            </span>
            <span translate>verify-id.component.try-again</span>
          </button>
        }

        <!--
          When the photo is already uploaded, but we are waiting for the validation response.
        -->
        @if (photoVerificationLoading()) {
          <div class="photo-validating" translate>verify-id.component.validating</div>
        }
      } @else {
        <div class="svg-wrapper">
          <lv-camera-feed
            [class.mirror]="isOnDesktop"
            filename="id.png"
            facing="environment"
            [keepRunning]="session.liveAgent"
            [cameraWidth]="photoGeometry.width"
            [cameraHeight]="photoGeometry.height"
            (capture)="capture($event)"
          ></lv-camera-feed>

          <img class="svg-item" src="assets/id-rect.svg" />
        </div>
      }
      @if (saving) {
        <div class="photo-uploading" translate>app.uploading</div>
      }
    </div>

    @if (photoVerificationResponse$ | async; as photoVerificationResponse) {
      @if (photoVerificationResponse.success) {
        @if (photoVerificationResponse.need_confirmation) {
          <lv-confirm-valid-id (confirmed)="onPhotoConfirmed($event)" label="confirm-next"></lv-confirm-valid-id>
        }
      } @else {
        <div class="no-face-detected">
          <div class="message-container">
            <div class="error-title" translate>verify-id.component.failed-title</div>

            <p translate>verify-id.component.failed-content</p>
          </div>

          <div class="error-button-container">
            <button class="button" (click)="reset()">
              <span class="icon">
                <i lvIcon="refresh"></i>
              </span>
              <span translate>verify-id.component.failed-retry</span>
            </button>
          </div>
        </div>
      }
    }
  </lv-photo-help>
</div>

<div class="body-footer">
  @if (showNextButton) {
    <div class="field is-grouped step-navigation">
      @if (canShowBack()) {
        <button class="button is-secondary is-fullwidth back-button" (click)="previous()">
          <span class="icon">
            <i lvIcon="long-arrow-left"></i>
          </span>
          <span translate>app.back</span>
        </button>
      }

      <button [disabled]="nextDisabled" class="button is-primary is-fullwidth next-button" (click)="done()">
        <span translate>app.next</span>
        <span class="icon">
          <i lvIcon="long-arrow-right"></i>
        </span>
      </button>
    </div>
  }
</div>
